import { ValidatorFn, AbstractControl, FormControl } from '@angular/forms';

export function patternValidator(regexp: RegExp): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const value = control.value;
    if (value === '') {
      return null;
    }
    // console.log(value, regexp.test(value));
    return !regexp.test(value) ? { patternInvalid: { regexp } } : null;
  };
}

export function reseller_dateValidation(formCtonrol: FormControl) {
  // const curYear = new Date().getFullYear();
  // const curMonth = new Date().getMonth();
  // const curDate = new Date().getDate();
  // const curDateValue = '' + curYear + curMonth + curDate
  // const newCurDateValue = Number(curDateValue)

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1 >= 10 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
  const currentDate = today.getDate() >= 10 ? today.getDate() : '0' + today.getDate();
  const curDateValue = '' + currentYear + currentMonth + currentDate
  console.log('today', curDateValue)
  const newCurDateValue = Number(curDateValue)
  // console.log('newCurDateValue', newCurDateValue)

  const formYear = new Date(formCtonrol.value).getFullYear();
  const formMonth = new Date(formCtonrol.value).getMonth();
  const formDate = new Date(formCtonrol.value).getDate();

  if(formMonth.toString().length === 1 || formDate.toString().length){
    const newFormMonth = formMonth + 1 >= 10 ? formMonth + 1 : '0' + (formMonth + 1);
    const newFormDate = formDate + 1 >= 10 ? formDate : '0' + formDate;
    const tmpNewFormDateValue = '' + formYear + newFormMonth + newFormDate;
    var newFormDateValue = Number(tmpNewFormDateValue)

    console.log('newFormDateValue', tmpNewFormDateValue)
  }


  console.log(newCurDateValue >= newFormDateValue)

  return formCtonrol.value.length == 0
    ? null
    : newCurDateValue >= newFormDateValue
      ? null
      : {
          validateDate: {
            valid: false
          }
        };
}
/**
 * example
 */
//EMAIL:
//patternValidator(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
//ANBNUMBER



// WEBPACK FOOTER //
// ./src/app/tooltip/validator.ts